export function ToggleOpenClosedNew(props) {
	const {
		onClick,
		openJobs,
		closedJobs,
		filterOpenStatus,
	} = props;
	
	const isShowingClosed = filterOpenStatus === 'closed';

	return (
		<div className="switch-container">
			<span
				className={`switch-label left ${
					!isShowingClosed ? 'active' : ''
				}`}
			>
				{openJobs}
			</span>
			<label className="switch-wrap">
				<input
					type="checkbox"
					checked={isShowingClosed}
					onChange={() => {
						const newStatus = isShowingClosed ? 'open' : 'closed';
						onClick(newStatus);
					}}
				/>
				<span className="switch-slider" />
			</label>
			<span
				className={`switch-label right ${
					isShowingClosed ? 'active' : ''
				}`}
			>
				{closedJobs}
			</span>
		</div>
	);
}
